import { ToolbarAndContentLayout } from './ToolbarAndContentLayout';
import { Layout } from 'src/common/primitives/Layout';

export function HeaderToolbarAndContentLayout({
  actionSection,
  preContent,
  content,
  searchbox,
}: {
  actionSection?: React.ReactNode;
  preContent?: React.ReactNode;
  content: React.ReactNode;
  searchbox?: React.ReactNode;
}) {
  return (
    <Layout>
      <ToolbarAndContentLayout
        actionSection={actionSection}
        preContent={preContent}
        content={content}
        searchbox={searchbox}
      />
    </Layout>
  );
}
